export const CONTACT = {
  phone: "404-703-2343",
  tel: "tel:+14047032343",
  email: "sales@huntshieldinsurance.com",
  domain: "insurance4teendrivers.com",
  agency: "Hunt Shield Insurance",
  state: "Georgia",
};

export const DISCOUNTS = [
  {
    id: "good-student",
    no: "01",
    title: "Good Student",
    tag: "Grades pay off",
    img: "/img/good-student.jpg",
    body: "Report cards count. Many carriers reward full-time students who keep strong grades, often a B average or better, because good students tend to be careful drivers.",
    claim: "Send us a recent report card or transcript and we apply it at quote and renewal.",
  },
  {
    id: "away-at-school",
    no: "02",
    title: "Student Away at School",
    tag: "Keys stay home",
    img: "/img/away-school.jpg",
    pos: "object-[center_32%]",
    body: "Is your teen heading to college without a car? When a student lives at school, often 100+ miles away, they drive your vehicles far less and the policy can reflect it.",
    claim: "Tell us the school and distance. We keep them covered when they come home on breaks.",
  },
  {
    id: "driver-training",
    no: "03",
    title: "Driver Training & Education",
    tag: "Trained, not guessing",
    img: "/img/driver-ed.jpg",
    body: "Completing an approved driver education course builds real skills, and many carriers recognize it. In Georgia, Joshua's Law already requires driver ed for a Class D license at 16, so the certificate can work twice.",
    claim: "Keep the completion certificate. One photo of it is all we need.",
  },
  {
    id: "telematics",
    no: "04",
    title: "Telematics Programs",
    tag: "Drive well, save more",
    img: "/img/telematics.jpg",
    body: "A phone app or small plug-in device notes smooth braking, steady speeds, phone-free driving and time of day. Safe habits can earn a discount, and parents get a quiet window into how the new driver is doing.",
    claim: "We help you pick the right program and get the app set up on day one.",
  },
];

export const STEPS = [
  { k: "Permit", t: "Call before the first lesson", d: "When your teen gets a Georgia learner's permit (Class CP), we review your policy so practice drives are protected." },
  { k: "Train", t: "Finish driver education", d: "Joshua's Law driver ed and supervised practice hours build skill and can line up the driver training discount." },
  { k: "License", t: "Add them with discounts stacked", d: "At the Class D license we add your teen and apply every discount they qualify for, all at once." },
  { k: "Keep", t: "Earn more as they grow", d: "New report cards, telematics scores and college moves can unlock more savings. We review at every renewal." },
];

export const FAQS = [
  { q: "Do I have to add my teen to my policy once they're licensed?", a: "In most cases, yes. A licensed household driver with access to your cars generally needs to be listed. Adding them correctly keeps claims from being disputed, and it is the moment to apply every discount." },
  { q: "Can my teen get more than one discount?", a: "Often, yes. Discounts like Good Student, Driver Training and Telematics can frequently be combined. Exact availability and amounts depend on the insurance company and your teen's eligibility, so we check each one for you." },
  { q: "Does a telematics app mean I'm spying on my teen?", a: "Think of it as coaching, not surveillance. Most programs share driving scores and trip summaries. Many families use it to talk about habits like hard braking or late-night driving." },
  { q: "What proof do I need for the Good Student discount?", a: "Usually a recent report card, transcript or a school form showing the grade average. Email a photo to us and we take care of the rest." },
  { q: "My teen is leaving for college. Should I remove them?", a: "Not usually. If they're going away without a car, the Student Away at School discount may lower the cost while keeping them covered when they drive at home on breaks." },
  { q: "Are you licensed in Georgia?", a: "Yes. Hunt Shield Insurance is a licensed property and casualty insurance agent in Georgia, helping Georgia families with auto, home and more." },
];
